import React, { useEffect, useState } from "react";
import { Outlet, RouteProps, useParams } from "react-router-dom";
import { contentSlice } from "../store/reducers";
import { RootState, useAppDispatch } from "../store";
import { contentDetail, contentSummary, loadContentDetail } from "../store/reducers/contentSlice";
import { useSelector } from "react-redux";

const ManagementContentDetail: React.FC = (prop) => {
  const dispatch = useAppDispatch();
  const parms: any = useParams();
  const [contentUid, setContentUid] = useState();
  const mobile = useSelector<RootState>(state => state.commonState.runningInMobile);

  useEffect(() => {
    var paramsContentuid = parms.contentUid;
    if (paramsContentuid !== contentUid) setContentUid(paramsContentuid);
  }, [parms]);

  useEffect(() => {
    if (!contentUid) return;
    dispatch(loadContentDetail(contentUid));
  }, [contentUid]);

  return <Outlet />;
};

export { ManagementContentDetail };
